export const API_URL = import.meta.env.VITE_API_URL as string;
export const MAINTENANCE_MODE = import.meta.env.VITE_MAINTENANCE_MODE as string;
